/** True when the port has no price per kWh. An unset price is not treated as zero here. */
export function isZeroTariff(costPerKwt) {
  if (costPerKwt === null || costPerKwt === undefined || costPerKwt === '') return false;
  return Number(costPerKwt) <= 0;
}

/**
 * Whether Pay should start the session without a bank checkout (balance, energy card, or free port).
 * `0` is a valid tariff; it must not be treated as a missing price.
 */
export function isChargeCoveredWithoutCheckout({ costPerKwt, kwt, balanceCents, energyCardCovers = false }) {
  if (energyCardCovers) return true;
  if (!kwt) return false;
  if (isZeroTariff(costPerKwt)) return true;
  if (!balanceCents || !costPerKwt) return false;
  return Number(balanceCents) >= Number(costPerKwt) * Number(kwt);
}
